/**
 * app.js
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2017 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        https://www.sudimage.fr
 * @created     30/05/2017
 */

/* global $, CCM_EDIT_MODE, BACKSTRETCH_IMAGES */

// @codekit-prepend "../node_modules/jquery-backstretch/src/jquery.backstretch.js";
// @codekit-prepend "./src/lib/jquery.scrolling.js";

const backstretchFade = 1000;
const $window = $(window);
const $document = $(document);
const $ccmPage = $('.ccm-page');
const $backstretchContainer = $('.backstretch-container');
const $navigation = $('.primary-navigation');
const $verticalNavigation = $('.vertical-navigation > ul');
const $html = $('html');

// @codekit-append "./src/_google-translate.js";
// @codekit-append "./src/_backstretch.js";
// @codekit-append "./src/_navigation.js";
// @codekit-append "./src/_vertical-navigation.js";
// @codekit-append "./src/_static_sidebar.js";
// @codekit-append "./src/_shortcuts-panel.js";
// @codekit-append "./src/_footer-bottom.js";